import { createContext, useContext } from "react";

export type EpocusClaimRefresh = {
  refreshed: unknown;
  refresh: () => Promise<void>;
};

export const EpocusClaimRefreshContext = createContext<
  EpocusClaimRefresh | undefined
>(undefined);

const noRefresh = async () => undefined;

export const useRefreshedEpocusClaim = (): unknown =>
  useContext(EpocusClaimRefreshContext)?.refreshed;

export const useEpocusClaimRefresh = (): (() => Promise<void>) =>
  useContext(EpocusClaimRefreshContext)?.refresh ?? noRefresh;
